import { ErrorContainer } from "./style"

export const NotFoundPage = () => {
  return (
    <ErrorContainer>
      <h1>Página não encontrada</h1>
    </ErrorContainer>
  )
}